import { render } from "./MapaFaenas.vue?vue&type=template&id=8cf937c2"
import script from "./MapaFaenas.vue?vue&type=script&lang=js"
export * from "./MapaFaenas.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__